import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import orange from '@material-ui/core/colors/orange';
import green from '@material-ui/core/colors/green';

import { selectReceiptStatus } from '../../../store/selectors';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginLeft: theme.spacing.unit,
  },
});

class ReceiptStatus extends Component {
  constructor(props){
    super(props);
    this.state = {
      anchorEl: null,
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, status } = this.props;

    const statusColor = function () {
      switch (status.warningLevel) {
        case "ok":
          return green[500];
        case "warning":
          return orange[500];
        default:
      }
    }();

    return(
      <div className={classes.root}>
        <Typography style={{color: statusColor}}>
          {status && status.displayStatus}
        </Typography>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { receipt } = props;
  const status = selectReceiptStatus(state, receipt);

  return ({
    status,
  });
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, null)
)(ReceiptStatus);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/ReceiptStatus.jsx